import { render, staticRenderFns } from "./LegalPolicy.vue?vue&type=template&id=6f604e0e&"
import script from "./LegalPolicy.vue?vue&type=script&lang=js&"
export * from "./LegalPolicy.vue?vue&type=script&lang=js&"
import style0 from "./LegalPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports